import React from "react";

import { StyledFlexibleBlock } from "./styled";

const FlexibleBlock = ({ styles, children }) => (
  <StyledFlexibleBlock styles={styles}>{children}</StyledFlexibleBlock>
);

export default FlexibleBlock;
